export default __webpack_public_path__ + "static/media/Group9251.a0a800fa.svg";